<div class="dialog-wrapper">
  <h3 mat-dialog-title>
    @if (hasIcon() && !data.list) {
    <mat-icon class="pointer" color="primary">{{ data.icon }}</mat-icon>
    }
    @if (data.title) {
    <ng-container>{{ data.title }}</ng-container>
    }
  </h3>
  <div mat-dialog-content>
    @if (hasEntries()) {
    <div class="dialog-detail-list">
      @for (entry of data.entries; track $index) {
      <div class="dialog-detail-row">
        <span class="dialog-detail-label">{{ entryLabel(entry) }}:</span>
        @if (isEntryArray(entry.value)) {
        <div class="dialog-detail-value text-truncate">
          @for (item of entry.value; track $index) {
          @if (isBoolean(item)) {
          <div>
            <mat-icon class="bool-icon" [class.bool-icon--true]="item" [class.bool-icon--false]="!item">
              {{ item ? 'check' : 'close' }}
            </mat-icon>
          </div>
          } @else {
          <div class="text-truncate" [matTooltip]="entryValue(item)" matTooltipClass="tooltip-multiline">
            {{ entryValue(item) | translate }}
          </div>
          }
          }
        </div>
        } @else {
        @if (isBoolean(entry.value)) {
        <span class="dialog-detail-value">
          <mat-icon class="bool-icon" [class.bool-icon--true]="entry.value" [class.bool-icon--false]="!entry.value">
            {{ entry.value ? 'check' : 'close' }}
          </mat-icon>
        </span>
        } @else {
        <span class="dialog-detail-value text-truncate" [matTooltip]="entryValue(entry.value)"
          matTooltipClass="tooltip-multiline">
          {{ entryValue(entry.value) | translate }}
        </span>
        }
        }
      </div>
      }
    </div>
    } @else {
    <div class="text" [innerHtml]="data.text"></div>
    @if (data.error) {
    <div class="text dialog-error" [innerHtml]="data.error"></div>
    }
    }
    @if (data.subtext) {
    <p class="subtext" [innerHtml]="data.subtext"></p>
    }
    @if (data.type === 'prompt') {
    <mat-form-field appearance="outline" class="w-100">
      <input type="text" matInput [formControl]="valueControl" />
    </mat-form-field>
    }
    @if (data.list) {
    <mat-chip-set>
      @for (item of data.list; track $index) {
      <mat-chip>
        @if (data.icon) {
        <mat-chip-avatar>
          <i [class]="data.icon" aria-hidden="true"></i>
        </mat-chip-avatar>
        }
        {{ item }}
      </mat-chip>
      }
    </mat-chip-set>
    }
  </div>
  <div mat-dialog-actions>
    <div class="dialog-actions">
      @if (data.type === 'prompt') {
      <div class="d-flex justify-content-end gap-2">
        <button mat-raised-button class="cancelButton" (click)="onNoClick()">
          <span>{{ 'shared.general.buttons.cancel' | translate }}</span>
        </button>
        <button mat-flat-button class="confirmButton" color="primary" (click)="onClick()">
          <span>{{ 'shared.general.buttons.confirm' | translate }}</span>
        </button>
      </div>
      }
      @if (data.type === 'confirm') {
      <div class="d-flex justify-content-end gap-2">
        <button mat-raised-button class="cancelButton" (click)="onNoClick()">
          <span>{{ 'shared.general.buttons.cancel' | translate }}</span>
        </button>
        <button mat-flat-button class="confirmButton" [class.confirmButton--error]="data.buttonColor === 'error'"
          [color]="data.buttonColor === 'error' ? 'warn' : data.buttonColor || 'primary'" (click)="onClick()">
          <span>{{ 'shared.general.buttons.confirm' | translate }}</span>
        </button>
      </div>
      }
      @if (data.type === 'alert') {
      <button mat-raised-button (click)="onClick()">
        <span>{{ 'shared.general.buttons.close' | translate }}</span>
      </button>
      }
    </div>
  </div>
</div>